export const INIT_STATE = 'INIT_STATE';
export const REQUEST_RECOVERY_FORM = 'REQUEST_RECOVERY_FORM';
export const RECOVERY_FORM_FIELDS = 'RECOVERY_FORM_FIELDS';
export const SEND_FORM = 'SEND_FORM';
export const VALIDATE = 'VALIDATE';
export const SET_ERRORS = 'SET_ERRORS';
export const CLEAR_ALL_ERRORS = 'CLEAR_ALL_ERRORS';
export const FINISHED_SEND_REQUEST = 'FINISHED_SEND_REQUEST';
export const FINISHED_RECOVERY_REQUEST = 'FINISHED_RECOVERY_REQUEST';
export const SET_SEND_FORM_RESPONSE = 'SET_SEND_FORM_RESPONSE';

export const CHANGE_FIELD_TITLE = 'CHANGE_FIELD_TITLE';
export const CHANGE_FIELD_TYPE_ID = 'CHANGE_FIELD_TYPE_ID';
export const CHANGE_FIELD_LOCALE_CODE = 'CHANGE_FIELD_LOCALE_CODE';
export const CHANGE_FIELD_COST_EXECUTION = 'CHANGE_FIELD_COST_EXECUTION';
export const CHANGE_FIELD_MAX_EXECUTIONS = 'CHANGE_FIELD_MAX_EXECUTIONS';
export const CHANGE_FIELD_DESC = 'CHANGE_FIELD_DESC';
export const CHANGE_FIELD_REQUIRE_LINK_IN_REPORT =
  'CHANGE_FIELD_REQUIRE_LINK_IN_REPORT';
export const CHANGE_FIELD_REQUIRE_SCREENSHOT_IN_REPORT =
  'CHANGE_FIELD_REQUIRE_SCREENSHOT_IN_REPORT';
export const CHANGE_FIELD_CHECK_TYPE = 'CHANGE_FIELD_CHECK_TYPE';
export const CHANGE_FIELD_LINKS = 'CHANGE_FIELD_LINKS';
export const CHANGE_FIELD_RANDOM_LINK = 'CHANGE_FIELD_RANDOM_LINK';
export const CHANGE_FIELD_ADULT_CONTENT = 'CHANGE_FIELD_ADULT_CONTENT';
export const CHANGE_FIELD_SOFTWARE_INSTALL = 'CHANGE_FIELD_SOFTWARE_INSTALL';
export const CHANGE_FIELD_TIME_CHECKING = 'CHANGE_FIELD_TIME_CHECKING';
export const CHANGE_FIELD_TIME_PERFORM = 'CHANGE_FIELD_TIME_PERFORM';
export const CHANGE_FIELD_EXECUTOR_EXECUTION_INTERVAL =
  'CHANGE_FIELD_EXECUTOR_EXECUTION_INTERVAL';
export const CHANGE_FIELD_EXECUTOR_EXECUTION_INTERVAL_CHECK =
  'CHANGE_FIELD_EXECUTOR_EXECUTION_INTERVAL_CHECK';
export const CHANGE_FIELD_CHECK_DESC = 'CHANGE_FIELD_CHECK_DESC';
export const CHANGE_FIELD_P_EXECUTOR_EMAIL_CONFIRM =
  'CHANGE_FIELD_P_EXECUTOR_EMAIL_CONFIRM';
export const CHANGE_FIELD_P_HIDE_FOR_BLACK_LIST =
  'CHANGE_FIELD_P_HIDE_FOR_BLACK_LIST';
export const CHANGE_FIELD_P_EXECUTOR_MIN_RATING =
  'CHANGE_FIELD_P_EXECUTOR_MIN_RATING';

export const CHANGE_FIELD_QUIZ_ADD_ASK = 'CHANGE_FIELD_QUIZ_ADD_ASK';
export const CHANGE_FIELD_QUIZ_DELETE_ASK = 'CHANGE_FIELD_QUIZ_DELETE_ASK';
export const CHANGE_FIELD_QUIZ_CHANGE_ASK = 'CHANGE_FIELD_QUIZ_CHANGE_ASK';
export const CHANGE_FIELD_QUIZ_ADD_ANSWER = 'CHANGE_FIELD_QUIZ_ADD_ANSWER';
export const CHANGE_FIELD_QUIZ_DELETE_ANSWER =
  'CHANGE_FIELD_QUIZ_DELETE_ANSWER';
export const CHANGE_FIELD_QUIZ_CHANGE_ANSWER =
  'CHANGE_FIELD_QUIZ_CHANGE_ANSWER';

export const CHANGE_FIELD_TIME_TARGET_ADD_WEEKDAYS =
  'CHANGE_FIELD_TIME_TARGET_ADD_WEEKDAYS';
export const CHANGE_FIELD_TIME_TARGET_DELETE_WEEKDAYS =
  'CHANGE_FIELD_TIME_TARGET_DELETE_WEEKDAYS';
export const CHANGE_FIELD_TIME_TARGET_CHANGE_WEEKDAYS =
  'CHANGE_FIELD_TIME_TARGET_CHANGE_WEEKDAYS';
export const CHANGE_FIELD_TIME_TARGET_ADD_TIME_RANGE =
  'CHANGE_FIELD_TIME_TARGET_ADD_TIME_RANGE';
export const CHANGE_FIELD_TIME_TARGET_DELETE_TIME_RANGE =
  'CHANGE_FIELD_TIME_TARGET_DELETE_TIME_RANGE';
export const CHANGE_FIELD_TIME_TARGET_CHANGE_TIME_RANGE_FROM =
  'CHANGE_FIELD_TIME_TARGET_CHANGE_TIME_RANGE_FROM';
export const CHANGE_FIELD_TIME_TARGET_CHANGE_TIME_RANGE_TO =
  'CHANGE_FIELD_TIME_TARGET_CHANGE_TIME_RANGE_TO';
export const CHANGE_FIELD_TIME_TARGET_CHANGE_TIME_MAX_AMOUNT =
  'CHANGE_FIELD_TIME_TARGET_CHANGE_TIME_MAX_AMOUNT';

export const CHANGE_FIELD_GEO_TARGET_TOGGLE_ITEM =
  'CHANGE_FIELD_GEO_TARGET_TOGGLE_ITEM';
export const CHANGE_FIELD_GEO_TARGET_CHANGE_TYPE_COMPARISON =
  'CHANGE_FIELD_GEO_TARGET_CHANGE_TYPE_COMPARISON';

// OTHER
export const CLEAR_LINK_ERROR_BY_KEY = 'CLEAR_LINK_ERROR_BY_KEY';
export const CLEAR_QUIZ_ASK_ERROR_BY_KEY = 'CLEAR_QUIZ_ASK_ERROR_BY_KEY';
export const CLEAR_QUIZ_ANSWER_ERROR_BY_KEYS =
  'CLEAR_QUIZ_ANSWER_ERROR_BY_KEYS';



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/reducers/dynamic/taskFrom/actionsTypes.js